import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { OnAccountService } from '../../_services/_masters/on-account.service';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import { Http, Response } from '@angular/http';
import { environment } from '../../../environments/environment';

import { SelectablesService } from '../../selectables.service';

import swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
// import * as $ from 'jquery';
declare var $ : any;

class OnAccountForm {
	account_name:string;
	address : string;
	branch: string;
	contact_no: string;
}

@Component({
  selector: 'app-on-account',
  templateUrl: './on-account.component.html',
  styleUrls: ['./on-account.component.css']
})
export class OnAccountComponent implements OnInit {

	onAccountForm : FormGroup;
	modalOnAccountForm : FormGroup;
	modalData : any;
	check_branch: boolean = true;

	// Data Table Configurations
	dtOptions: any = {};
	dataTable: any;
	dtTrigger: Subject<any> = new Subject();
	on_account_form: OnAccountForm[] = [];

	stations : string[] = [];
	currentUser  : any ;
	token : any ;
	user_role : string = null ;
	user_branch : string = null ;

	url = environment.url;
	@ViewChild(DataTableDirective)
	dtElement: DataTableDirective;

	query : any = null;
	response : any = null;

	constructor( private onAccountService : OnAccountService,
				private selectBranchService : SelectablesService,
		 		private http: Http) { }

	ngOnInit() {
		this.onAccountForm = new FormGroup({
			'account_name': new FormControl(null , Validators.required),
			'address': new FormControl(null , Validators.required),
			'branch': new FormControl(null , Validators.required),
			'contact_no':new FormControl(null , Validators.required)
		});
		this.modalOnAccountForm = new FormGroup({
			'account_name': new FormControl(null , Validators.required),
			'address': new FormControl(null , Validators.required),
			'branch': new FormControl(null , Validators.required),
			'contact_no':new FormControl(null , Validators.required)
		});


		this.dtOptions = {
			pagingType: 'full_numbers',
			pageLength: 5,
			responsive: true,
			// select:true,
			rowCallback: (row: Node, data: any[] | Object, index: number) => {
				const self = this;
				// Unbind first in order to avoid any duplicate handler
				// (see https://github.com/l-lin/angular-datatables/issues/87)
				$('td', row).unbind('click');
				$('td', row).bind('click', () => {
					self.someClickHandler(data);
				});
				return row;
			},
			dom: 'Bfrtip',
			// Configure the buttons
			buttons: [
				// 'columnsToggle',
				'colvis',
				'copy',
				'print',
				'excel'
			]
		};

		this.http.get(this. url + '/masters/onaccount/all')
		// this.http.get('http://backendtransport.iogreen.in/masters/onaccount/all')
			.map(this.extractData)
			.subscribe(forms => {
				this.on_account_form = forms;
				console.log(this.on_account_form);
				// Calling the DT trigger to manually render the table
				this.dtTrigger.next();
			});

		var myObject = localStorage.getItem('currentUser');
		var temp = JSON.parse(myObject);	
		if(localStorage.getItem('currentUser'))
		{
			if (temp["role"] === 'Admin')
			{
				this.getBranch();
				this.check_branch = false;
			}
			else if(temp['role'] === 'Manager' || temp['role'] === 'Employee')
			{
				this.onAccountForm.get('branch').setValue(temp['branch']);
				this.check_branch = true;
			}
		}
	}
	getBranch()
    {
     	this.selectBranchService.getBranches()
		.subscribe(
			branches => {
				for(var i=0;i<branches.length;i++)
				{
					this.stations.push(branches[i]['branch_name']);
				}
			});
    }
	
	private extractData(res: Response) {
		const body = res.json();
		console.log(body.data || {});
		return body;

	};

	someClickHandler(info: any): void {
		this.onAccountService.getAccountFormWith(info[0])
		.subscribe(response => {
			console.log('aaaaa'+JSON.stringify(response))
			this.modalData = JSON.stringify(response)
			this.modalData =JSON.parse(this.modalData)
			this.modalOnAccountForm.patchValue({
				"account_name": this.modalData[0].account_name,
				'branch': this.modalData[0].branch,
				"contact_no": this.modalData[0].contact_no,
				"address": this.modalData[0].address
			});
		});	
		$("#default-modal").modal('show');
	};

	submit(){
		console.log(this.onAccountForm.value);
		//this.onAccountService.addNewAccount(this.onAccountForm.value)
		//.subscribe(response => console.log(response));

		this.onAccountService.addNewAccount(this.onAccountForm.value)
		.subscribe(response => 
		{
			
			if(response['status'])
			{
				swal('Save', 'Record save successfully', 'success');
				this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
					dtInstance.destroy();
					this.http.get(this.url + '/masters/onaccount/all')
						.map(this.extractData)
						.subscribe(forms => {
						this.on_account_form = forms;
						console.log(this.on_account_form);
						// Calling the DT trigger to manually render the table
						this.dtTrigger.next();
					});
				});
				
			}
			else
			{
				swal('Oops!', 'Something went wrong on the page!', 'error');
			}
		});
	};

	updateOnAccount(){
		console.log(this.modalOnAccountForm.value);
		console.log(this.modalData);

		this.query={
			"on_account_oid" : this.modalData[0]._id,
			"on_account_data" : this.modalOnAccountForm.value
		}

		console.log(this.query);

		this.http.post( this.url + "/masters/onaccount/update", this.query)
		.subscribe(res => { 
			console.log(res.json());
			this.response = res.json();
			console.log(this.response.status);
			if (this.response.status){

				if (this.response.message === 'On-Account Updated Successfully'){
					swal(
						'Success',
						'On-Account Form Updated Successfully',
						'success'
					);

					this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
						dtInstance.destroy();
						this.http.get(this.url + '/masters/onaccount/all')
							.map(this.extractData)
							.subscribe(forms => {
							this.on_account_form = forms;
							console.log(this.on_account_form);
							// Calling the DT trigger to manually render the table
							this.dtTrigger.next();
						});
					});
				}

				if (this.response.message === 'On-Account Information not Changed'){
					swal(
						'Info',
						'On-Account information not changed',
						'info'
					);
				}
			}
			else{
				swal(
					'Unknown Error',
					'Please Refresh your page',
					'error'
				);
			}
			
		});
	};

	// DELETE CONSIGNOR
	deleteOnAccount(){
		console.log("Hello");
		this.query={
			"onaccount_id" : this.modalData[0]._id.$oid,
			"branch": this.modalData[0].branch
		}
		console.log(this.query);
		swal({
			title: 'Are you sure?',
			text: 'You want to delete On-account',
			type: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'No, keep it'
		}).then((result) => {
			if (result.value) {
			
				this.http.post(this.url + '/masters/onaccount/delete', this.query)
				.map(response => response.json())
				.subscribe(
					(response)=>{
						console.log(response);
						if (response["status"]){
							
							console.log(response);
							console.log("success");
							swal('Deleted!','Your On-account has been deleted.','success');
							this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
								dtInstance.destroy();
								this.http.get(this.url + '/masters/onaccount/all')
									.map(this.extractData)
									.subscribe(forms => {
									this.on_account_form = forms;
									console.log(this.on_account_form);
									// Calling the DT trigger to manually render the table
									this.dtTrigger.next();
								});
							});

							$("#default-modal").modal("hide");
						}else{
							swal("error","Oops , Somthing went wrong, On-account is not deleted","error");
						}
					},
					(error)=>console.log(error.json())
					);

			} 
		})
	}

	// END

}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/masters/on-account/on-account.component.ts